import type { ReactNode } from "react";
import { cn } from "../utils/cn";

type TableCellProps = {
  children: ReactNode;
  className?: string;
};

export function TableCell({ children, className }: TableCellProps) {
  return <div className={cn("text-sm text-text", className)}>{children}</div>;
}
